export const spacing = {
    gutterWidth: {
        value: '1rem',
    },
    gutterWidthDesktop: {
        value: '1.5rem',
    },
    gutterHeight: {
        value: '1.5rem',
    },
    sectionGap: {
        value: '3rem',
    },
    sectionGapDesktop: {
        value: '5rem',
    },
    headerOffset: {
        value: '62px',
    },
    containerWidth: {
        value: '1320px',
    },
    oldContainerWidth: {
        // It's deprecated and will be removed after redesign (used in checkout)
        value: '100rem',
    },
};
